import React, { useMemo } from 'react';
import { CaretLeft } from '@phosphor-icons/react';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';

import { trackClickBackButton } from '../../../analytics';

import { Button } from '../../../components/general';
import { URL } from '../../../constants';

import useSampleProjectData from '../../../hooks/useSampleProjectData';
import { useWindowWidth } from '../../../hooks/useWindowWidth';

import { useProjectStore } from '../../../stores/project';

import { getUrl, getVBLinkParts, getBpWidth } from '../../../utils';

interface Props {
  onClick?: () => void;
  label?: string;
  className?: string;
}

const BackBtn: React.FC<Props> = (props) => {
  const navigate = useNavigate();

  const { onClick, label, className } = props;

  const { currentProject } = useProjectStore();

  const { eventId, page } = getVBLinkParts(window.location.pathname);

  // sample project data
  const { isSample } = useSampleProjectData(eventId);

  const windowWidth = useWindowWidth();
  const isMobileDevice = useMemo(
    () => windowWidth < getBpWidth('lg'),
    [windowWidth],
  );

  const openVB = () => {
    navigate(
      getUrl(
        currentProject?.isAssigneeAccess ? URL.VB_ASSIGNEE : URL.VIDEO_BUILDER,
        eventId,
      ),
    );

    trackClickBackButton(page, isSample);
  };

  return (
    <Button
      onClick={() => (onClick ? onClick() : openVB())}
      variant={isMobileDevice ? 'primary' : 'primary-thin'}
      colour={isMobileDevice ? 'custom' : 'transparent-grey'}
      className={classNames(
        'w-full lg:w-min mb-6 sm:mb-10 lg:mb-2 lg:p-2 text-left whitespace-nowrap',
        isMobileDevice &&
          'px-[5vw] py-4 border-y border-grey-200 border-solid rounded-none',
        className,
      )}
    >
      <div className="w-full flex items-center gap-2">
        <CaretLeft />
        {label ?? 'Back'}
      </div>
    </Button>
  );
};

export default BackBtn;
